/* import __COLOCATED_TEMPLATE__ from './hue-slider.hbs.js'; */
import { computed } from '@ember/object';
/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */
import { htmlSafe } from '@ember/template';
import Component from '@ember/component';

/**
## hue slider
`hue-slider` is used by the hsv-color-picker to choose the Hue value that pertains
to the HSV or HSL color space. It uses a mostly invisible `<input type="range">`
to handle user input. It's mostly invisible because customizing the appearance
of this element is a big hassle. Instead, we just render our own "thumb" and "track".
The only extra JavaScript required is to position our custom thumb.

```example
@title Basic Example

@hbs
{{hue-slider hue=hue onchange=(action (mut hue))}}

@controller-properties
{
  hue: 100
}
```

### Parameters
@param {number} [hue] The value that should be sent to the range input. A number in [0, 360].
@param {action} [onchange] This action is sent when the user changes the value of the range
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['hue-slider'],
  sliderThumbStyle: computed('hue', function () {
    return htmlSafe(`bottom: ${this.hue * 100 / 360}%;`);
  }),
  actions: {
    change(e) {
      this.onchange?.(e.target.value);
    }
  }
});